import type { Timesheet } from '@/types/timesheet'
import { PureDate } from './absolute-datetime'

export const calculateTotalHours = (lines: Timesheet['lines']): number => {
	let totalMinutes = 0

	for (const line of lines) {
		const start = new PureDate(line.start)
		const end = new PureDate(line.end)
		const diffMinutes = start.diffMinutes(end)
		totalMinutes += diffMinutes
	}

	return totalMinutes / 60
}

export const formatHours = (hours: number): string => {
	const totalMinutes = Math.round(hours * 60)
	const h = Math.floor(totalMinutes / 60)
	const m = totalMinutes % 60

	if (h === 0) {
		return `${m}m`
	}
	if (m === 0) {
		return `${h}h`
	}
	return `${h}h ${m}m`
}

export const getLocationParts = (location?: string): { lat?: string; lon?: string } => {
	if (!location) return {}
	const parts = location.trim().split(/[,\s]+/)
	if (parts.length < 2) {
		return { lat: location }
	}
	return { lat: parts[0], lon: parts[1] }
}

export const getMapsUrl = (location?: string): string | null => {
	const { lat, lon } = getLocationParts(location)
	if (!lat || !lon) return null
	return `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`
}

export const normalizeText = (text: string) =>
	text
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
